import React from 'react';
import { CTAButton } from '../CTAButton';
import { deliverables } from '../../data/content';
export function Deliverables() {
  return <section className="w-full bg-white px-4 py-12 sm:py-16" data-id="element-114" data-mp="106pxt9on9lq1">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="mejifptbfirn">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-116" data-mp="mfl56rjp1tp7">
          What Will You Receive Immediately After Your Purchase?
        </h2>

        <ul className="mt-8 space-y-3.5" data-id="element-117" data-mp="1e5fyt0el45jo">
          {deliverables.map(item => <li key={item.title} className="flex gap-4 rounded-2xl border border-navy/10 bg-cream p-4 sm:p-5" data-id="element-118" data-mp="1j2pv900e5hh0">
              <span aria-hidden="true" className="text-2xl leading-none" data-id="element-119" data-mp="1a3b7i8blzl07">
                {item.emoji}
              </span>
              <div data-id="element-120" data-mp="3pu7eb8fso804">
                <h3 className="text-[15px] font-extrabold leading-snug text-navy-deep sm:text-base" data-id="element-121" data-mp="3ptnxjv1vrpno">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-[14px] font-medium leading-relaxed text-ink/70" data-id="element-122" data-mp="ee62p6xl4vv4">
                  {item.text}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-123" data-mp="oc2fs4a320vv">
          <CTAButton label="I want to receive everything today" sub="Access delivered to your email within minutes" data-id="element-124" data-mp="odx1hkt6hx10" />
        </div>
      </div>
    </section>;
}